import PropTypes from 'prop-types';

import { DateSlot } from './date-slot';
import { dateUtils } from '~/routes/utils';

export const BookingDate = ({
  slot: {
    date: dateString,
    time: { from, to },
  },
  formatTimeSlot = null,
  children = [],
}) => {
  const date = dateUtils.getDateFromString(dateString);
  const format = formatTimeSlot || dateUtils.getTimeSlotFormattedTime;
  return (
    <DateSlot date={date}>
      <time>{format(from, to)}</time>
      {children}
    </DateSlot>
  );
};

BookingDate.propTypes = {
  slot: PropTypes.shape({}).isRequired,
  formatTimeSlot: PropTypes.func,
  children: PropTypes.node,
};
